export enum TemplateTypeOfScore {
    POINTS = 'POINTS',
    PERCENTAGES = 'PERCENTAGES'
}
